module.exports = __webpack_public_path__ + "img/prize-02-pic.c3bd505b.png";